import { render, staticRenderFns } from "./linkedperson.vue?vue&type=template&id=4cac9786"
import script from "./linkedperson.vue?vue&type=script&lang=ts"
export * from "./linkedperson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports